// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UNge+","buttonContainer":"styles_buttonContainer__y71dY","mobileSwap":"styles_mobileSwap__01DF8","swap":"styles_swap__LBkqZ"};